"use strict";var e=require("react").createContext({});exports.WidgetControllerContext=e;
//# sourceMappingURL=WidgetControllerContext-B2xWjpQh.js.map
